import { languageList, menuCountryPartners, menuHeader } from 'utils/menu';
import { IoChevronDown } from 'react-icons/io5';
import { BsCheck } from 'react-icons/bs';
import { HiMenu } from 'react-icons/hi';
import { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { LanguageItem } from 'models/languageModel';
import './Header.scss';
import { MenuChanel, MenuCountryPartner } from 'models/menuModel';
import classNames from 'classnames';
import { Link } from 'react-router-dom';

interface Props {
    onChangeRoute: (routeValue: MenuChanel) => void;
    onChangeCountryRoute: (routeValue:  MenuCountryPartner) => void;
    countryLottery: MenuCountryPartner;
    countrySelected: string;
    language: LanguageItem;
    onChangeLanguage: (lang: LanguageItem) => void;
    onShowMenuMobile: () => void;
}

export default function Header(props: Props) {
    const { onChangeRoute, countrySelected, countryLottery, language, onChangeLanguage, onShowMenuMobile, onChangeCountryRoute } = props;

    const { t } = useTranslation();
    const languageRef = useRef<HTMLDivElement>(null);

    function handleClickOutside(event: any) {
        if (languageRef.current && !languageRef.current.contains(event.target)) {
            languageRef.current.classList.remove('open');
        }
    }

    useEffect(() => {
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [languageRef]);

    const onOpenLanguage = () => {
        if (languageRef.current) languageRef.current.classList.add('open');
    };

    const handleChangeCountry = (item: MenuCountryPartner) => {
        onChangeCountryRoute(item);
    };

    const handleChangeRoute = (item: MenuChanel) => {
        onChangeRoute(item);
    }

    const handleChangeLanguage = (item: LanguageItem) => {
        if (languageRef.current) {
            languageRef.current.classList.remove('open');
        }
        onChangeLanguage(item);
    };

    return (
        <div className="headerWrapper">
            <div className="headerContent">
                <button type="button" className="btn-menu-mobile" onClick={onShowMenuMobile}>
                    <HiMenu size={36} />
                </button>
                {/* logo */}
                <Link className="logo" to="/">
                    <img src={require('assets/images/logos/logo.png')} alt="" />
                </Link>
                <div className="choice-country-result-container">
                    <button className="btn-show-dropdown-country">
                        <svg xmlns="http://www.w3.org/2000/svg" width="36.212" height="26.45" viewBox="0 0 36.212 26.45">
                            <g id="Group_989" data-name="Group 989" transform="translate(-641.282 -151.652)">
                                <path id="Path_302" data-name="Path 302" d="M658.338,173.284a8.8,8.8,0,0,1-1.442-.117.513.513,0,0,1-.427-.427l-.406-2.557c-.072-.029-.144-.056-.214-.086l-2.1,1.521a.526.526,0,0,1-.607,0,9.4,9.4,0,0,1-1.1-.937,8.838,8.838,0,0,1-.937-1.106.512.512,0,0,1,0-.6l1.519-2.1c-.029-.07-.061-.14-.09-.212l-2.55-.4a.52.52,0,0,1-.429-.431,8.843,8.843,0,0,1,0-2.886.515.515,0,0,1,.429-.424l2.55-.408c.029-.072.061-.142.09-.217l-1.517-2.092a.508.508,0,0,1,0-.6,8.433,8.433,0,0,1,.939-1.108,8.747,8.747,0,0,1,1.1-.937.519.519,0,0,1,.6,0l2.09,1.519.217-.09.406-2.55a.517.517,0,0,1,.427-.431,9.053,9.053,0,0,1,2.889,0,.523.523,0,0,1,.427.431l.406,2.55c.072.029.142.059.214.09l2.092-1.521a.522.522,0,0,1,.609,0,8.733,8.733,0,0,1,2.036,2.04.515.515,0,0,1,0,.6l-1.517,2.1c.032.072.059.144.086.214l2.557.408a.508.508,0,0,1,.427.424,8.743,8.743,0,0,1,0,2.889.515.515,0,0,1-.426.429l-2.555.4c-.029.074-.056.147-.086.214l1.517,2.092a.522.522,0,0,1,0,.6,9.242,9.242,0,0,1-.934,1.108,9.543,9.543,0,0,1-1.108.937.526.526,0,0,1-.6,0l-2.094-1.519c-.068.029-.138.059-.212.088l-.406,2.557a.518.518,0,0,1-.427.427A8.917,8.917,0,0,1,658.338,173.284Zm-.909-1.085a7.93,7.93,0,0,0,1.821,0l.395-2.476a.518.518,0,0,1,.343-.408,5.513,5.513,0,0,0,.67-.278.519.519,0,0,1,.535.045l2.031,1.471q.352-.281.684-.6a8.719,8.719,0,0,0,.6-.684l-1.471-2.029a.514.514,0,0,1-.043-.537,5.486,5.486,0,0,0,.273-.666.52.52,0,0,1,.408-.345l2.478-.395a7.927,7.927,0,0,0,0-1.821l-2.48-.393a.522.522,0,0,1-.408-.35,5.867,5.867,0,0,0-.275-.668.511.511,0,0,1,.047-.53l1.469-2.031a7.657,7.657,0,0,0-1.284-1.289l-2.031,1.476a.514.514,0,0,1-.535.043,5,5,0,0,0-.664-.273.519.519,0,0,1-.35-.413l-.395-2.473a7.93,7.93,0,0,0-1.821,0l-.393,2.473a.517.517,0,0,1-.345.411,4.849,4.849,0,0,0-.666.275.518.518,0,0,1-.537-.043l-2.029-1.474a7.7,7.7,0,0,0-.682.6,7.991,7.991,0,0,0-.609.682l1.476,2.029a.515.515,0,0,1,.043.533,5.618,5.618,0,0,0-.275.67.524.524,0,0,1-.411.348l-2.471.393a7.926,7.926,0,0,0,0,1.821l2.476.395a.517.517,0,0,1,.411.345,4.926,4.926,0,0,0,.275.67.52.52,0,0,1-.043.533l-1.476,2.029a8.416,8.416,0,0,0,.609.684,7.764,7.764,0,0,0,.682.6l2.029-1.471a.515.515,0,0,1,.533-.045,5.15,5.15,0,0,0,.67.275.527.527,0,0,1,.345.411Zm.912-3.841a3.968,3.968,0,1,1,2.812-1.162A3.946,3.946,0,0,1,658.34,168.357Zm0-6.915a2.939,2.939,0,1,0,2.081.864A2.923,2.923,0,0,0,658.34,161.442Z" transform="translate(10.254 4.818)" fill="#fff" />
                                <path id="Path_303" data-name="Path 303" d="M649.7,157.175a1.961,1.961,0,1,1,1.963-1.961A1.964,1.964,0,0,1,649.7,157.175Zm0-2.891a.929.929,0,1,0,.93.93A.931.931,0,0,0,649.7,154.284Z" transform="translate(8.109 2.012)" fill="#fff" />
                                <path id="Path_304" data-name="Path 304" d="M645.313,162.485a1.962,1.962,0,1,1,1.961-1.963A1.966,1.966,0,0,1,645.313,162.485Zm0-2.891a.928.928,0,1,0,.928.928A.928.928,0,0,0,645.313,159.594Z" transform="translate(2.598 8.682)" fill="#fff" />
                                <path id="Path_305" data-name="Path 305" d="M650.976,158.4l-.095-.129c-.041.12-.083.246-.126.366l.131-.02C650.915,158.54,650.947,158.47,650.976,158.4Z" transform="translate(11.906 8.314)" fill="#fff" />
                                <path id="Path_306" data-name="Path 306" d="M660.241,171.076a.519.519,0,0,1-.291-.156,10.536,10.536,0,0,1-4.967,2.579,13.215,13.215,0,0,0,3.128-3.78h1.6a7.928,7.928,0,0,1,0-1.036h-1.092a13.36,13.36,0,0,0,1.131-4.96h1.833a8.576,8.576,0,0,1,.715-.817c.075-.072.156-.144.235-.217h-2.785a13.45,13.45,0,0,0-.767-3.9,1.957,1.957,0,0,1-.961.386,12.284,12.284,0,0,1,.693,3.514H653.36v-4.947h2.557a1.831,1.831,0,0,1,0-1.034H653.36v-3.618a12.328,12.328,0,0,1,2.952,2.866,1.956,1.956,0,0,1,.858-.587,13.494,13.494,0,0,0-2.379-2.5,10.532,10.532,0,0,1,6.306,3.841h-1.4a1.886,1.886,0,0,1,0,1.034h2.119a10.4,10.4,0,0,1,1.474,4.317c.041-.029.077-.063.115-.09a.519.519,0,0,1,.6,0l.334.241a11.574,11.574,0,0,0-11.469-10.56h-.007l-.034,0a11.559,11.559,0,0,0-9.67,5.245.538.538,0,0,0-.072.113,11.51,11.51,0,0,0-.016,12.367.514.514,0,0,0,.126.2,11.551,11.551,0,0,0,9.632,5.186l.09,0c.025,0,.047-.011.07-.014a.506.506,0,0,0,.065.009h.009a11.507,11.507,0,0,0,8.057-3.541Zm-9.3-18.219a13.357,13.357,0,0,0-3.259,3.852H644.57A10.544,10.544,0,0,1,650.937,152.857Zm-7.084,4.886h3.3a13.27,13.27,0,0,0-1.192,4.947h-3.634A10.441,10.441,0,0,1,643.853,157.743Zm8.472,10.941H649.8a1.951,1.951,0,0,1,0,1.036h2.523v3.527a12.8,12.8,0,0,1-2.893-2.805,2.009,2.009,0,0,1-.846.6,13.625,13.625,0,0,0,2.444,2.528,10.523,10.523,0,0,1-6.448-3.85h1.438a1.894,1.894,0,0,1,0-1.036h-2.157a10.414,10.414,0,0,1-1.532-4.96h3.629a12.831,12.831,0,0,0,.776,3.909,1.96,1.96,0,0,1,.964-.381,11.793,11.793,0,0,1-.7-3.527h5.331Zm0-5.994H647a12.334,12.334,0,0,1,1.3-4.947h4.028Zm0-5.981h-3.442a12.342,12.342,0,0,1,3.442-3.6Zm1.036,7.014h5.36a12.363,12.363,0,0,1-1.234,4.96H653.36Zm0,6h3.55a12.338,12.338,0,0,1-3.55,3.708Z" transform="translate(0 0)" fill="#fff" />
                            </g>
                        </svg>
                        LOCATION
                        <svg className="dropdown-icon" focusable="false" viewBox="0 0 24 24" aria-hidden="true" role="presentation"><path d="M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z"></path></svg>
                    </button>
                    <ul className="dropdown-country-container">
                        {
                            menuCountryPartners.map((value, index) => {
                                return (
                                    <li key={index + 'country-lottery'} onClick={() => handleChangeCountry(value)}>
                                        <img src={value.icon} alt="" />
                                        {value.name}
                                        <BsCheck size={24} className={countryLottery.code === value.code ? 'active' : ''} />
                                    </li>
                                );
                            })
                        }
                    </ul>
                </div>

                {/* menu list */}
                <ul className="menuList">
                    {menuHeader.map((menu, index) => (
                        <li className="menuItem" key={index}>
                            <p
                                className={classNames('countryName', { active: menu.route === countrySelected })}
                                onClick={() => handleChangeRoute(menu)}
                            >
                                {t(`${menu.name}`)}
                            </p>
                        </li>
                    ))}
                </ul>

                {/* language */}
                <div className="language">
                    <button type="button" className="btnLanguage">
                        <img src={language.image} alt="" />
                        <p>{language.name}</p>
                    </button>

                    {/* list language option */}
                    <div className="optionLanguage" ref={languageRef}>
                        <ul className="languageList">
                            {languageList.map((item, index) => (
                                <li key={index} className="languageItem" onClick={() => handleChangeLanguage(item)}>
                                    <BsCheck size={24} className={item.value === language.value ? 'active' : ''} />
                                    <img src={item.image} alt="" />
                                    <span>{item.name}</span>
                                </li>
                            ))}
                        </ul>
                    </div>
                    {/* //list language option */}
                </div>
            </div>
        </div>
    );
}
